// Author Liang Gang Qiang
// Date 2021-11-24 16:34:50

class MintalMesQualitySelfInspectPelletize {
constructor({
        id = null,
        selfInspectId = '',
        selfInspectCode = '',
        sampleTime = '',
        inspectTime = '',
        moistureBentonite = '',
        moistureLimestone = '',
        moistureFilterCake = '',
        moistureQh = '',
        moistureSq = '',
        intensityFall = '',
        intensityWet = '',
        intensityDry = '',
        inspector = '',
        status = '',
        remark = ''}
= {}) {
    this.id = id;
    this.selfInspectId = selfInspectId;
    this.selfInspectCode = selfInspectCode;
    this.sampleTime = sampleTime;
    this.inspectTime = inspectTime;
    this.moistureBentonite = moistureBentonite;
    this.moistureLimestone = moistureLimestone;
    this.moistureFilterCake = moistureFilterCake;
    this.moistureQh = moistureQh;
    this.moistureSq = moistureSq;
    this.intensityFall = intensityFall;
    this.intensityWet = intensityWet;
    this.intensityDry = intensityDry;
    this.inspector = inspector;
    this.status = status;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesQualitySelfInspectPelletize();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sampleTime',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.sampleTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspectTime',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.inspectTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'moistureBentonite',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.moistureBentonite',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'moistureLimestone',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.moistureLimestone',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'moistureFilterCake',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.moistureFilterCake',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'moistureQh',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.moistureQh',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'moistureSq',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.moistureSq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'intensityFall',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.intensityFall',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'intensityWet',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.intensityWet',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'intensityDry',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.intensityDry',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'inspector',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.inspector',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    selfInspectIdFilter : '',
    selfInspectCodeFilter : '',
    sampleTimeRteFilter : '',
    sampleTimeLteFilter : '',
    inspectTimeRteFilter : '',
    inspectTimeLteFilter : '',
    moistureBentoniteFilter : '',
    moistureLimestoneFilter : '',
    moistureFilterCakeFilter : '',
    moistureQhFilter : '',
    moistureSqFilter : '',
    intensityFallFilter : '',
    intensityWetFilter : '',
    intensityDryFilter : '',
    inspectorFilter : '',
    statusFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'selfInspectCodeFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.selfInspectCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualitySelfInspect'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"selfInspectId": "id"}'
                }
        },
        {
        key: 'sampleTimeRteFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.sampleTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sampleTimeLteFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.sampleTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inspectTimeRteFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.inspectTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'inspectTimeLteFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.inspectTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'moistureBentoniteFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.moistureBentonite',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'moistureLimestoneFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.moistureLimestone',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'moistureFilterCakeFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.moistureFilterCake',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'moistureQhFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.moistureQh',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'moistureSqFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.moistureSq',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intensityFallFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.intensityFall',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intensityWetFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.intensityWet',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intensityDryFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.intensityDry',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'inspectorFilter',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.filter.inspector',
        disabled: false,
        form: {
        type: 'input'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'selfInspectCode',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.entity.selfInspectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesQualitySelfInspect'
            ,correspondingField: 'code'
            ,fieldsBindingByEntityModalSelected: '{"selfInspectId": "id"}'
                }
        },
        {
        key: 'sampleTime',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.entity.sampleTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'inspectTime',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.entity.inspectTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker'
                }
        },
        {
        key: 'moistureBentonite',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.entity.moistureBentonite',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'moistureLimestone',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.entity.moistureLimestone',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'moistureFilterCake',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.entity.moistureFilterCake',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'moistureQh',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.entity.moistureQh',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'moistureSq',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.entity.moistureSq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intensityFall',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.entity.intensityFall',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intensityWet',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.entity.intensityWet',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'intensityDry',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.entity.intensityDry',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'inspector',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.entity.inspector',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualitySelfInspectPelletize.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesQualitySelfInspectPelletize, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
